export default {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Хуудас",
  jump_to_confirm: "confirm",
  //   page: "Page",

  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size",
};
